export const navs_zh = {
  title: '开发者文档',
  array: [
    {
      key: '1',
      title: '平台介绍',
      // route: '/main/guide/introduce',
      array: [
        {
          key: '1_1',
          title: '操作说明',
          route: '/main/guide/introduce',
          array: [],
        },
      ],
    },
    {
      key: '2',
      title: '云对云',
      array: [
        {
          key: '2_1',
          title: '规范说明',
          route: '/main/specification',
          array: [],
        },
        {
          key: '2_2',
          title: 'OAuth 2.0 认证',
          route: '/main/oauthApi',
          array: [],
        },
        {
          key: '2_3',
          title: '开放接口',
          route: '/main/openApi',
          array: [],
        },
        {
          key: '2_4',
          title: '数据推送',
          route: '/main/webhook',
          array: [],
        },
        {
          key: '2_5',
          title: 'SDK 支持说明',
          route: '/main/ccSdk',
          array: [],
        },
        {
          key: '2_6',
          title: '产品接入指引',
          route: '/main/guide/product',
          // array: [
          //   {
          //     key: '2_6_2',
          //     title: '青萍空气检测仪',
          //     route: '/main/guide/snow',
          //   },
          //   {
          //     key: '2_6_8',
          //     title: '青萍空气检测仪 Lite',
          //     route: '/main/guide/dany',
          //   },
          //   {
          //     key: '2_6_3',
          //     title: '青萍商用温湿度/气压计',
          //     route: '/main/guide/pheasant',
          //   },

          //   {
          //     key: '2_6_6',
          //     title: '青萍商用温湿度计 E',
          //     route: '/main/bussiness/frog',
          //   },
          // ],
        },
      ],
    },

    {
      key: '3',
      title: '私有化',
      array: [
        {
          key: '3_1',
          title: '接入说明',
          route: '/main/private/device_private',
          array: [],
        },
        {
          key: '3_2',
          title: '青萍空气检测仪',
          route: '/main/private/snow_private',
          array: [],
        },
        {
          key: '3_3',
          title: '公有 MQTT 通讯协议',
          route: '/main/private/public_mqtt',
          array: [],
        },
        {
          key: '3_4',
          title: '商用温湿度/气压计 LoRaWAN Modbus 协议',
          route: '/main/private/lorawan',
          array: [],
        },
        {
          key: '3_5',
          title: '二氧化碳和温湿度检测仪 LoRaWAN Modbus 协议',
          route: '/main/private/lorawan_co2',
          array: [],
        },
        {
          key: '3_6',
          title: '内环境检测仪 LoRa Modbus 协议',
          route: '/main/private/lora_indoor_modbus',
          array: [],
        },
      ],
    },
  ],
}

export const navs_en = {
  title: 'Docs',
  array: [
    {
      key: '1',
      title: 'Introduction',
      array: [
        {
          key: '1_1',
          title: 'Platform Introductions',
          route: '/main/guide/introduce',
          array: [],
        },
      ],
    },
    {
      key: '2',
      title: 'Cloud to Cloud',
      array: [
        {
          key: '2_1',
          title: 'Specification',
          route: '/main/specification',
          array: [],
        },
        {
          key: '2_2',
          title: 'OAuth 2.0',
          route: '/main/oauthApi',
          array: [],
        },
        {
          key: '2_3',
          title: 'Open API',
          route: '/main/openApi',
          array: [],
        },
        {
          key: '2_4',
          title: 'Data Push',
          route: '/main/webhook',
          array: [],
        },
        {
          key: '2_5',
          title: 'SDK Instructions',
          route: '/main/ccSdk',
          array: [],
        },
        {
          key: '2_6',
          title: 'Products Access Instructions',
          route: '/main/guide/product',
          array: [],
          // array: [
          //   {
          //     key: '2_6_2',
          //     title: 'Qingping Air Monitor',
          //     route: '/main/guide/snow',
          //   },
          //   {
          //     key: '2_6_8',
          //     title: 'Qingping Air Monitor Lite',
          //     route: '/main/guide/dany',
          //   },
          //   {
          //     key: '2_6_3',
          //     title: 'Qingping Temp & RH Barometer',
          //     route: '/main/guide/pheasant',
          //   },
          //   {
          //     key: '2_6_6',
          //     title: 'Qingping Temp & RH Monitor Pro E',
          //     route: '/main/bussiness/frog',
          //   },
          // ],
        },
      ],
    },
    {
      key: '3',
      title: 'Private Access',
      array: [
        {
          key: '3_1',
          title: 'Private Access Instructions',
          route: '/main/private/device_private',
          array: [],
        },
        {
          key: '3_2',
          title: 'Qingping Air Monitor',
          route: '/main/private/snow_private',
          array: [],
        },
        {
          key: '3_3',
          title: 'MQTT Protocol',
          route: '/main/private/public_mqtt',
          array: [],
        },
        {
          key: '3_4',
          title: 'Temp & RH Barometer Pro LoRaWAN Modbus Protocol',
          route: '/main/private/lorawan',
          array: [],
        },
        {
          key: '3_5',
          title: 'CO2 & Temp & RH Monitor LoRaWAN Modbus Protocol',
          route: '/main/private/lorawan_co2',
          array: [],
        },
        {
          key: '3_6',
          title: 'Indoor Environment Monitor LoRa Modbus Protocol',
          route: '/main/private/lora_indoor_modbus',
          array: [],
        },


      ],
    },
  ],
}
